import { Outlet, useParams } from 'react-router-dom'

import getSubscription from 'modules/app_store/hooks/useFetchData'
import DocumentTemplateDetails from 'modules/documents/components/DocumentTemplates/DocumentTemplateDetails'
import Loading from 'modules/layout/components/Page/Loading'

const DocumentTemplateDetailsPage = () => {
  const { id, documentTemplateId } = useParams()
  const { loading } = getSubscription(id)

  if (loading) return <Loading />

  return (
    <>
      <DocumentTemplateDetails documentTemplateId={Number(documentTemplateId)} />
      <Outlet />
    </>
  )
}

export default DocumentTemplateDetailsPage
